import {APIEvents} from "../../../constants/AnalyticsEventKeys";
import {MobileAnalyticsHelper} from "@amzn/dolphin-web-framework";
import {getNPSWClient} from "../../base/ClientInterface";

export function getExceptionShipmentSummaryDetails(data, dispatcher, nextAction, errorAction) {
    let startTime = Date.now();
    getNPSWClient().getExceptionShipmentSummaryDetails(data)
        .then(({success, data}) => {
            if (success) {
                dispatcher({
                    type: nextAction,
                    data: data,
                    dispatcher: dispatcher
                });
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.ExceptionShipmentSummaryReport, startTime);
            } else {
                dispatcher({
                    type: errorAction
                });
                MobileAnalyticsHelper.executeAPIAnalytics(APIEvents.ExceptionShipmentSummaryReport, startTime, true);
            }
        });
}